// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */
export type {
	GenericAggregatorClient,
	AggregatorClientFeatures,
	Props as ClientContextProviderProps,
} from './aggregator-client-context';

export {
	AggregatorClientContextProvider,
	useAggregatorClient,
	useTypedAggregatorClient,
} from './aggregator-client-context';

// TODO: Remove this and have a more descriptive experience
export const PLACEHOLDER_EXPERIENCE = 'product-search-dialog';
